// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flash-wrapper[data-v-384eed38]{z-index:1070;width:100%;position:relative;top:0}@supports(position: sticky){.flash-wrapper[data-v-384eed38]{position:sticky}}.flash-message[data-v-384eed38]{border:1px solid transparent;border-radius:0;margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
